import { Component, Input, ContentChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { AppSwitcherService } from '../../../services/service/app-switcher.service';

@Component({
    selector: 'zx-applet-selector-content',
    templateUrl: './applet-selector-content.component.html',
    styleUrls: ['./applet-selector-content.component.css'],
})
export class AppletSelectorContentComponent {

    @ContentChild('content', {static:true}) tpl_content: TemplateRef<void>;

    constructor(
        public appSwitcher: AppSwitcherService,
    ) { }

    @Input() collapseMode:boolean;
    @Input() appletsRoot: any;
    @Output() changeApplet = new EventEmitter<any>();

    
    get appletsTree(): any{
        return this.appSwitcher.appletsTree;
    }
    get currentApplet(): any{
        return this.appSwitcher.currentApp;
    }
    get applets():any[]{
        const parentId = this.appletsRoot?this.appletsRoot.id:null;
        return parentId!=null?this.appSwitcher.allApplets.filter(item=>item.parent!=null&&item.parentId==parentId&&item.visible&&item.resourceType=="APPLICATION"):[];
    }

    isLock(applet:any){
        return this.appSwitcher.isAppLock(applet);
    }

    go(applet: any) {
        if(applet&&applet.resourceType=="APPLICATION"&&!this.isLock(applet)){
            this.changeApplet.emit(applet);
        }
    }
}
